// extracted by mini-css-extract-plugin
export default {"icon":"PlusButton-module__icon__gYH6U"};